import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import "./patientByid.scss";


const PatientByID = () => {
    let location = useLocation();
    const [individualPatient, setIndividualPatient] = useState([])

    useEffect(() => {
        const fetchPatientById = () => {
            axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${location?.state?.patientDetails?.uniqueID}`).
                then(res => {
                    if (res?.status === 200) setIndividualPatient(res?.data?.result)
                }).catch(err => { console.error(err) })
        }
        fetchPatientById()
    }, [location?.state?.patientDetails?.uniqueID])
    return (
        <div className="patient-info-id">
            <div className="row">
                <div className="column">
                    <div className="card">
                        <div className="card-details">
                            <div className="profile-img">
                                <img src="https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png" className="rounded-circle" />
                                {/* <i className="fa fa-edit"></i> */}
                            </div>
                            {/* <div className="name d-flex justify-content-between">
                                <h4 className="name-tag">{individualPatient?.basicDetail?.name}</h4>
                                <Button variant="contained" className="ml-5 btn-actve">Active</Button>
                            </div> */}
                        </div>

                    </div>
                </div>
                {/* <div className="column">
                    <div className="card">
                        <h3>Card 2</h3>
                        <p>Some text</p>
                        <p>Some text</p>
                    </div>
                </div> */}



            </div>
        </div>
        // <div className="patient-info-id">
        //     <div className="patient-by-id-card col-sm-6">
        //         <div className="profile-body">
        // <div className="profile-img">
        //     <img src="https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png" className="rounded-circle" />
        //     <i class="fa fa-edit"></i>
        // </div>
        //             <div className="card-details">
        //                 <div className="name d-flex justify-content-between">
        //                     <h4 className="name-tag">{individualPatient?.basicDetail?.name}</h4>
        //                     <Button variant="contained" className="ml-5 btn-actve">Active</Button>
        //                 </div>
        //                 <div className="user-details">
        //                     <div className="d-flex">
        //                         <p className="key-tag">Age:</p>
        //                         <p className="ml-2 value-tag">{individualPatient?.basicDetail?.age}</p>
        //                     </div>
        //                     <div className="postion d-flex ml-5">
        //                         <p className="key-tag">Emr:</p>
        //                         <p className="value-tag">{individualPatient?.basicDetail?.emrNumber}</p>
        //                     </div>
        //                 </div>
        //                 <div className="email">
        //                     <div className="d-flex">
        //                         <p className="key-tag">Email:</p>
        //                         <p className="ml-2 value-tag">{individualPatient?.basicDetail?.email}</p>
        //                     </div>
        //                 </div>
        //                 <div className="email">
        //                     <div className="d-flex">
        //                         <p className="key-tag">Gender:</p>
        //                         <p className="ml-2 value-tag">{individualPatient?.basicDetail?.gender}</p>
        //                     </div>
        //                 </div>
        //                 <div className="email">
        //                     <div className="d-flex">
        //                         <p className="key-tag">Mobile:</p>
        //                         <p className="ml-2 value-tag">{individualPatient?.basicDetail?.mobile}</p>
        //                     </div>
        //                 </div>

        //             </div>
        //         </div>
        //     </div>
        //         <div className="col-sm-6">
        //             <PatientInsurance timelineData={mockJson} />
        //         </div>
        //         <div className="col-sm-6 mt-2"><PatientByIdBasicDetails /></div>
        // </div>
    )
}

export default PatientByID